import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { cn } from 'helpers/css';

const FlashContainer = ({ className = '', value, render }) => {
  const [isFlashing, setIsFlashing] = useState(false);
  const prevValueRef = useRef(undefined);

  useEffect(() => {
    if (prevValueRef.current !== undefined && prevValueRef.current !== value) {
      setIsFlashing(true);

      const timeoutId = setTimeout(() => {
        setIsFlashing(false);
      }, 500);

      return () => clearTimeout(timeoutId);
    }

    prevValueRef.current = value;
  }, [value]);

  const flashClasses = `tw-transition-colors tw-duration-500 ${
    isFlashing ? 'tw-bg-yellow-200 dark:tw-text-black' : 'tw-bg-transparent'
  }`;

  if (render) {
    return (
      <div className={cn(`tw-rounded-sm ${flashClasses} tw-inline-block`, className)}>{render}</div>
    );
  }

  return (
    <div className={cn(`tw-rounded-sm tw-inline-block ${flashClasses}`, className)}>
      <p>{value}</p>
    </div>
  );
};

export default FlashContainer;
